import { PrintShipViewProps } from "./PrintShip/Params"
import { PrintShipGeneralView } from "./PrintShip/GeneralView"
import { PrintShipDimensionsView } from "./PrintShip/DimensionsView"
import { PrintShipInsurancesView } from "./PrintShip/InsurancesView"
import { PrintShipInsideView } from "./PrintShip/InsideView"
import { PrintShipEnginesView } from "./PrintShip/EnginesView"
import { PrintShipGeneratorsView } from "./PrintShip/GeneratorsView"
import { PrintShipSteeringView } from "./PrintShip/SteeringView"
import { PrintShipTanksView } from "./PrintShip/TanksView"
import { PrintShipRigView } from "./PrintShip/RigView"
import { PrintShipSailsView } from "./PrintShip/SailsView"
import { PrintShipDevicesView } from "./PrintShip/DevicesView"
import { PrintShipAnchorsView } from "./PrintShip/AnchorsView"
import { PrintShipOtherEquipmentView } from "./PrintShip/OtherEquipmentView"
import { PrintShipUsersView } from "./PrintShip/UsersView"

// Re-export the shared ship-print context (owned by App/Context) and the pure
// print-layout logic (owned by PrintShip/Context) so existing
// `from "./PrintShipView"` imports keep working.
export { GetPrintShipViewContext, PrintShipViewContext, ShipDataType } from "../App/Context"
export type { PrintShipViewContextData } from "../App/Context"
export { PrintShipViewData, predefined } from "./PrintShip/Context"
export type { PrintShipViewProps } from "./PrintShip/Params"

// Thin composer of the ship print sections. Each section owns its own guards
// (detail-level gate, data-presence, user-list) and resolves its own shipData.
export function PrintShipView({ data, users }: PrintShipViewProps) {
  return (
    <div className="PrintShipView">

      {/* General Information and photo */}
      <PrintShipGeneralView data={data} />

      {/* Vessel Type with sketch; dimensions */}
      <PrintShipDimensionsView data={data} />

      {/* Insurances - ShipDataInsuranceView */}
      <PrintShipInsurancesView data={data} />

      {/* Inside */}
      <PrintShipInsideView data={data} />

      {/* Engines - ShipDataEngineView */}
      <PrintShipEnginesView data={data} />

      {/* Generators  - ShipDataGenView */}
      <PrintShipGeneratorsView data={data} />

      {/* SteeringSystem */}
      <PrintShipSteeringView data={data} />

      {/* Tanks – ShipDataTankView */}
      <PrintShipTanksView data={data} />

      {/* Rig – ShipDataRigView */}
      <PrintShipRigView data={data} />

      {/* Sails  – ShipDataSailView */}
      <PrintShipSailsView data={data} />

      {/* Devices – ShipDataDeviceView: electric, nautical, safety */}
      <PrintShipDevicesView data={data} />

      {/* Anchors */}
      <PrintShipAnchorsView data={data} />

      {/* Other Equipment – ShipDataOtherEquipmentView */}
      <PrintShipOtherEquipmentView data={data} />

      {/* List of users */}
      <PrintShipUsersView users={users} />

    </div>
  );
}
